import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Button, FullColumn, Row } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { AiWorkingOnIt } from '~/components/ai/AiWorkingOnIt/AiWorkingOnIt';
import { useScrollBorder } from '~/hooks/useScrollBorder';
import styles from './SuggestedOutputDisplay.module.scss';
import { SuggestedOutputDisplayTestIds } from './SuggestedOutputDisplay.utils';
const SuggestedOutputDisplay = (param)=>{
    let { isLoading, isUndoLoading, output, clarificationText, isClarification, canUndo, hasExistingContent, isInserting, outputRenderer, texts, onInsert, onUndo } = param;
    const [hasExistingContentAtInsert, setHasExistingContentAtInsert] = useState(null);
    const contentRef = useRef(null);
    const { footerClassName: actionRowClassName } = useScrollBorder({
        contentRef,
        footerBaseClassName: styles.actionRow
    }, [
        output,
        isLoading
    ]);
    useEffect(()=>{
        setHasExistingContentAtInsert(null);
    }, [
        output
    ]);
    const handleInsertButtonClick = ()=>{
        if (output == null) return;
        onInsert();
        setHasExistingContentAtInsert(hasExistingContent);
    };
    const handleUndoClick = ()=>{
        onUndo();
    };
    if (isLoading) {
        return /*#__PURE__*/ _jsx(AiWorkingOnIt, {
            testId: SuggestedOutputDisplayTestIds.Loading()
        });
    }
    if (isClarification || clarificationText != null && output == null) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.clarificationText,
            "data-testid": SuggestedOutputDisplayTestIds.SuggestedDescription(),
            children: clarificationText !== null && clarificationText !== void 0 ? clarificationText : ''
        });
    }
    if (output == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(FullColumn, {
        className: styles.root,
        justifyContent: "space-between",
        testId: SuggestedOutputDisplayTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(FullColumn, {
                className: styles.content,
                children: /*#__PURE__*/ _jsx("div", {
                    ref: contentRef,
                    className: styles.contentWrapper,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.descriptionContent,
                        children: outputRenderer({
                            value: output
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Row, {
                justifyContent: "end",
                gap: 8,
                className: actionRowClassName,
                children: [
                    canUndo && !isClarification && /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'undo_help_me_write_suggestion'
                        },
                        skin: "primaryOutline",
                        size: "small",
                        testId: SuggestedOutputDisplayTestIds.UndoButton(),
                        onClick: handleUndoClick,
                        disabled: isInserting || isUndoLoading,
                        loading: isUndoLoading,
                        children: texts.undoLabel
                    }),
                    (()=>{
                        const isInserted = hasExistingContentAtInsert != null;
                        const shouldShowReplaceButton = isInserted ? hasExistingContentAtInsert : hasExistingContent;
                        if (shouldShowReplaceButton) {
                            return /*#__PURE__*/ _jsx(Button, {
                                bi: {
                                    name: 'replace'
                                },
                                size: "small",
                                testId: SuggestedOutputDisplayTestIds.ReplaceButton(),
                                onClick: !isInserted ? handleInsertButtonClick : undefined,
                                prefixIcon: isInserted ? /*#__PURE__*/ _jsx(Checkmark, {
                                    size: 16
                                }) : undefined,
                                className: isInserted ? styles.insertedButton : undefined,
                                disabled: isUndoLoading,
                                children: isInserted ? texts.replacedLabel : texts.replaceLabel
                            });
                        }
                        return /*#__PURE__*/ _jsx(Button, {
                            bi: {
                                name: 'insert'
                            },
                            size: "small",
                            testId: SuggestedOutputDisplayTestIds.InsertButton(),
                            onClick: !isInserted ? handleInsertButtonClick : undefined,
                            prefixIcon: isInserted ? /*#__PURE__*/ _jsx(Checkmark, {
                                size: 16
                            }) : undefined,
                            className: isInserted ? styles.insertedButton : undefined,
                            disabled: isUndoLoading,
                            children: isInserted ? texts.insertedLabel : texts.insertLabel
                        });
                    })()
                ]
            })
        ]
    });
};
export default SuggestedOutputDisplay;
